export default __webpack_public_path__ + "static/media/ic_calendar.a0ff1d81.svg";